@if (showResultTile) {
	<tec-tile
		[title]="'PROCESSES.DETAIL.RESULT' | translate"
		[subtitle]="showKoDisclaimer ? ('PROCESSES.DETAIL.KO_DISCLAIMER' | translate) : ''"
		[tag]="'MASTER.STATUS.' + statusKey | translate"
		[tagStatus]="masterService.getTagStatus(statusKey)"
		icon="icon-pending-check"
		[styling]="'default'"
	>
		@if (statusKey === PROCESS_STATUS.PENDING && !hideReviewAction) {
			<ng-container actions>
				<tec-button
					[label]="'BUTTON.CHECK' | translate"
					[ghost]="true"
					(clickEvent)="goToReview($event)"
				/>
			</ng-container>
		}
		@if (statusKey === PROCESS_STATUS.PENDING && !hideReviewAction) {
			{{ 'PROCESSES.DETAIL.PENDING_DISCLAIMER' | translate }}
		}
		@if (operationStateTags.length) {
			<div class="detail-result-tile__op-states" style="display: flex; flex-wrap: wrap; gap: 8px; align-items: center;">
				@for (op of operationStateTags; track op.type) {
					<span style="display: inline-flex; gap: 6px; align-items: center;">
						<span>{{ ('PROCESSES.DETAIL.' + op.type) | translate }}</span>
						<tec-tag
							[label]="'MASTER.STATUS.' + op.state | translate"
							[status]="masterService.getTagStatus(op.state)"
						/>
					</span>
				}
			</div>
		}
		@if (checksDetail && showKoDisclaimer) {
			<app-checks
				[detail]="checksDetail"
				[exclusiveKoCompletionMessageOcr]="processHelper.getKoCompletionExclusiveMessageForOcr(checksDetail)"
				[exclusiveKoCompletionMessagePol]="processHelper.getKoCompletionExclusiveMessageForPol(checksDetail)"
				showOnlyKO
			></app-checks>
		}
		@if (formMatchKoMessage) {
			<tec-item
				[classes]="['item--outline']"
				[outline]="true"
				[tagImage]="{ icon: 'icon-info', status: 'simple' }"
				[tagIcon]="{ icon: 'icon-alert', status: 'error', size: 'sm' }"
				[title]="formMatchKoMessage.title"
				[clickeable]="false"
			>
				@if (formMatchKoMessage.subtitle) {
					<span>{{ formMatchKoMessage.subtitle }}</span>
				}
			</tec-item>
		}
		@if (processMatchKoMessage && !checksDetail?.data?.OCR?.actions?.KO) {
			<tec-item
				[classes]="['item--outline']"
				[outline]="true"
				[tagImage]="{ icon: 'icon-info', status: 'simple' }"
				[tagIcon]="{ icon: 'icon-alert', status: 'error', size: 'sm' }"
				[title]="processMatchKoMessage.title"
				[clickeable]="false"
			>
				@if (processMatchKoMessage.subtitle) {
					<span>{{ processMatchKoMessage.subtitle }}</span>
				}
			</tec-item>
		}
		@if (operationDetail?.status_reasons || processDetail?.status_reasons) {
			<span>{{ 'PROCESSES.DETAIL.RESULT_STATUS_MANUAL_HINT' | translate }}</span>
			<p>
				<strong>{{ 'PROCESSES.DETAIL.RESULT_REASONS_LABEL' | translate }}:</strong>
				{{ operationDetail?.status_reasons ?? processDetail?.status_reasons }}
			</p>
		}
	</tec-tile>
}
